const toggleBtn = document.querySelector('.sidebar-toggle')
const closeBtn = document.querySelector('.close-btn')
const sidebar = document.querySelector('.filters-sidebar')

toggleBtn.addEventListener('click', () => {
    sidebar.classList.toggle('show-sidebar')
    if(sidebar.classList.contains('show-sidebar')){
    }
}
)
closeBtn.addEventListener('click', () => {
    sidebar.classList.remove('show-sidebar')
})

window.addEventListener('scroll', () => {
    if(window.scrollY > 144){
      sidebar.style.height = '91.5%'
    } else {
      sidebar.style.height = '85%'

    }
  })